import { GetterTree } from 'vuex';
import { ProuniState } from './state';
import RootState from '@/store/root_state';
import { ProuniApplication, ProuniDocument, ProuniEligibility, ProuniFamilyMember } from './types';

const getters: GetterTree<ProuniState, RootState> = {
  prouniApplication: (state): ProuniApplication | null => state.application,
  prouniEligibility: (state): ProuniEligibility | null => state.eligibility,
  prouniStatus: (state): string | undefined => state.application?.status,
  prouniRa: (state): string | null | undefined => state.application?.ra,
  prouniRejectionReason: (state): string | null | undefined => state.application?.rejectionReason,
  prouniDocuments: (state): ProuniDocument[] => state.application?.documents || [],
  prouniFamilyMembers: (state): ProuniFamilyMember[] => state.application?.familyMembers || [],
  prouniPipelineState: (state): Record<string, any> | null | undefined =>
    state.application?.pipelineState,
};

export default getters;
